<template>
    <div :id="id" element="TextComponent" class="sitebuilder-element-container"
         :style="style()"
         :data-hide-desktop="!this.internal_config.showDesktop"
         :data-hide-mobile="!this.internal_config.showMobile"
         :data-editing="this.editing">


        <!--      <div v-html="internal_config.order_mobile" style="text-align: center"></div>-->

        <p class="text-center sitebuilder-element desktop-element" v-show="!this.editing"
           :style="'font-size: '+ internal_config.fontSize + ' !important;font-weight: '+ internal_config.weight "
           v-html="internal_config.content"></p>
        <p class="text-center sitebuilder-element mobile-element"
           :style="'font-size: '+ internal_config.fontSizeMobile + ' !important;font-weight: '+ internal_config.weight + ';'"
           v-html="internal_config.content"></p>
    </div>
</template>

<script>

	import TextData from './Model';
	import Resources from './Resources.vue';

	export default {
		name: 'TextComponent',
		props: ['config', 'id', 'preview'],
		components: {
			TextData,
			Resources
		},
		data() {
			return TextData.data();
		},
		methods: {


			build(config) {
				this.internal_config = config;
				this.internal_config.content = this.internal_config.content.replace(/&nbsp;/g, ' ');
			},

			style() {
				return `width: ${this.internal_config.width};
                left:  ${this.internal_config.left};
                padding-top: ${this.internal_config.paddingTop};
                padding-left: ${this.internal_config.paddingLeft};
                padding-right: ${this.internal_config.paddingRight};
                     z-index: ${this.internal_config.zIndex};
                padding-bottom: ${this.internal_config.paddingBottom};
                top: ${this.internal_config.top}`;
			}
		},
		mounted() {
			this.build(this.$props.config);

			Object.keys(this.props).forEach(prop => {
				if (typeof this.internal_config[prop] === 'undefined') {
					this.internal_config[prop] = this.props[prop];
				}
			});

			this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @media (max-width: 980px) {
        .desktop-element {
            display: none;
        }

        .mobile-element {
            display: block;
        }
    }

    @media (min-width: 981px) {
        .desktop-element {
            display: block;
        }

        .mobile-element {
            display: none;
        }
    }

    .auto-height {
        height: auto !important;
    }

</style>

